import type { FileData } from 'ricos-schema';
import { Node_Type } from 'ricos-schema';

import type { NodeBuilder } from './types';

export const file = (...args: (NodeBuilder | FileData)[]): NodeBuilder => {
  const fileData = args.find((a): a is FileData => !('type' in a));
  const nodeBuilders = args.filter((a): a is NodeBuilder => 'type' in a && a.type === 'block_node');

  return {
    type: 'block_node',
    // @ts-expect-error
    node: getId => ({
      id: getId(),
      type: Node_Type.FILE,
      ...(nodeBuilders.length && {
        nodes: nodeBuilders.map(nb => nb.node(getId)),
      }),
      fileData: fileData ? fileData : {},
    }),
  };
};
